import { render, staticRenderFns } from "./create-document.vue?vue&type=template&id=3052dc58&scoped=true"
import script from "./create-document.vue?vue&type=script&lang=js"
export * from "./create-document.vue?vue&type=script&lang=js"
import style0 from "./create-document.vue?vue&type=style&index=0&id=3052dc58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3052dc58",
  null
  
)

export default component.exports